import React from 'react';
import {observable, action, computed, makeObservable, runInAction} from 'mobx';
import {observer} from 'mobx-react';
import PaymentAddr from './paymentAddr';
import PaypalButtonComponent from './paypalButton';
import store from '../../s';
import PaymentCodes from './paymentCodes';
import {checkout, klaviyo_identify} from '../../../api';
import PaymentMethod from './paymentMethod';
import * as util from '../../../util';
// import StripePaymentRequestButton from './stripe';
import ModalPromo from '../modals/promo';
declare var modalOpen: any;
declare var OpenLink: any;

@observer
class PaymentComponent extends React.Component {
    @observable showCodes: boolean;
    @observable hidePayment: boolean;
    @observable placingCCOrder: boolean = false;
    @observable test: boolean = false;

    constructor(props) {
        super(props);
        this.placeOrder = this.placeOrder.bind(this);
        this.placeOrderMyFrames = this.placeOrderMyFrames.bind(this);
        this.placingCCOrder = false;
        this.hidePayment = false;
        this.reloadPayment = this.reloadPayment.bind(this);
        store.checkoutReloadPayment = this.reloadPayment;
        makeObservable(this);
    }

    @action
    placeOrder = async () => {
        this.placingCCOrder = true;
        store.uiCheckout.processing = true;
        setTimeout(function () {
            store.uiCheckout.processing = false;
        }, 20000);

        try {
            const success = await checkout('cc-place-order');
            runInAction(() => {
                // approved ria
                this.placingCCOrder = false;
                if (success && store.checkout.cstep === ICheckoutStep.success) {
                    location.reload();
                } else {
                    store.uiCheckout.processing = false;
                }
            });
        } catch (_err) {
            runInAction(() => {
                // approved ria
                console.error(_err);
                store.uiCheckout.processing = false;
                this.placingCCOrder = false;
            });
        }
    };

    @action
    placeOrderMyFrames = async () => {
        store.uiCheckout.processing = true;
        const success = await checkout('myf-place-order');
        store.uiCheckout.processing = false;
        if (store.checkout.cstep === ICheckoutStep.success) {
            OpenLink('/view-order');
        }
    };

    @action
    reloadPayment = async () => {
        if (store.checkout.CheckoutType !== ICheckoutType.paypal_express) {
            this.hidePayment = true;
            setTimeout(() => {
                this.hidePayment = false;
            }, 200);
        }
    };

    @action
    reloadPaymentFailure = async () => {
        if (store.checkout.CheckoutType !== ICheckoutType.paypal_express) {
            this.hidePayment = true;
            setTimeout(() => {
                this.hidePayment = false;
            }, 200);
        }
    };

    @computed get isTestOrder() {
        try {
            return store.checkout.notes_customer.toLowerCase().includes('marketing-test-order') || store.checkout.notes_gift.toLowerCase().includes('marketing-test-order');
        } catch (err5) {
            return false;
        }
    }

    render() {
        return (
            <div>
                <div className="row">
                    <div className="col-12">
                        <PaymentAddr />
                    </div>
                </div>

                {store.checkout.cstep === ICheckoutStep.paymentAddr && !store.checkout.isMyFrames && (
                    <div className="payment-codes">
                        <div className="row">
                            <div className="col-12">
                                <button
                                    className="link text-btn"
                                    type="button"
                                    aria-label="Enter gift card or promo code button"
                                    onClick={() => modalOpen('modal-checkout-promo')}
                                >
                                    + Do you have a {store.PortalID === 3 ? 'promo code' : 'gift card or promo code'}?{' '}
                                    <span style={{paddingLeft: 4}}>
                                        <i
                                            className="fas fa-tags"
                                            aria-hidden={true}
                                        />
                                    </span>
                                </button>
                            </div>
                        </div>
                        <ModalPromo
                            reloadPayment={this.reloadPayment}
                            reloadPaymentFailure={this.reloadPaymentFailure}
                            modalId="modal-checkout-promo"
                        />
                    </div>
                )}

                {store.checkout.cstep === ICheckoutStep.payment && !store.checkout.isMyFrames && (
                    <div className="payment-codes">
                        <div className="row">
                            <div className="col-12">
                                {!this.showCodes && (
                                    <div>
                                        <button
                                            className="link text-btn"
                                            type="button"
                                            aria-label="Enter gift card or promo code button"
                                            onClick={() => (this.showCodes = true)}
                                        >
                                            + Do you have a {store.PortalID === 3 ? 'promo code' : 'gift card or promo code'}?{' '}
                                            <span style={{paddingLeft: 4}}>
                                                <i
                                                    className="fas fa-tags"
                                                    aria-hidden={true}
                                                />
                                            </span>
                                        </button>
                                    </div>
                                )}
                                {this.showCodes && (
                                    <div className="col-12">
                                        <PaymentCodes
                                            reloadPayment={this.reloadPayment}
                                            reloadPaymentFailure={this.reloadPaymentFailure}
                                            promoOnly={false}
                                        />
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                )}

                {/* {store.checkout.cstep === ICheckoutStep.payment && !(store.checkout.code_gift_applied && store.checkout.cart.pricing.total <= 0) && !(store.checkout.code_promo_applied && store.checkout.cart.pricing.total <= 0) && <PaymentMethod />} */}

                {store.checkout.messages
                    .filter(o => o.msgType === ICheckoutMessageType.paypal || o.msgType === ICheckoutMessageType.stripe || o.msgType === ICheckoutMessageType.generic)
                    .map((o, i) => (
                        <div className="row">
                            <div className="col-12">
                                <div
                                    key={i}
                                    className="alert alert-danger form-error"
                                >
                                    <div className="error-title">Payment Error</div>
                                    <div>{o.msg && o.msg.toString()}</div>
                                </div>
                            </div>
                        </div>
                    ))}

                {store.checkout.ship.messages
                    .filter(o => o.msgType === ICheckoutMessageType.paypal || o.msgType === ICheckoutMessageType.stripe || o.msgType === ICheckoutMessageType.generic)
                    .map((o, i) => (
                        <div className="row">
                            <div className="col-12">
                                <div
                                    key={i}
                                    className="alert alert-danger form-error"
                                >
                                    <div className="error-title">Payment Error (Shipping)</div>
                                    <div>{o.msg && o.msg.toString()}</div>
                                </div>
                            </div>
                        </div>
                    ))}

                {store.checkout.billing.messages
                    .filter(o => o.msgType === ICheckoutMessageType.paypal || o.msgType === ICheckoutMessageType.stripe || o.msgType === ICheckoutMessageType.generic)
                    .map((o, i) => (
                        <div className="row">
                            <div className="col-12">
                                <div
                                    key={i}
                                    className="alert alert-danger form-error"
                                >
                                    <div className="error-title">Payment Error (Billing)</div>
                                    <div>{o.msg && o.msg.toString()}</div>
                                </div>
                            </div>
                        </div>
                    ))}

                {store.checkout.isMyFrames && store.checkout.cstep === ICheckoutStep.payment && (
                    <div className="payment-codes">
                        <div className="row">
                            <div className="col-12 text-center">
                                <button
                                    type="button"
                                    className={`btn btn-checkout btn-checkout-yellow${store.PortalID === 3 ? ' btn-checkout-yellow-portal3' : ''}`}
                                    aria-label="Place MyFrames Order"
                                    onClick={this.placeOrderMyFrames}
                                >
                                    Place MyFrames Order
                                </button>
                            </div>
                        </div>
                    </div>
                )}
                {!store.checkout.isMyFrames &&
                    store.checkout.cstep === ICheckoutStep.payment &&
                    store.checkout.cart.pricing.total <= 0 &&
                    (store.checkout.cart.pricing.discount != 0 || store.checkout.cart.pricing.gift != 0) &&
                    store.checkout.code_promo.value &&
                    store.checkout.code_promo.value.length > 0 && (
                        <div className="payment-codes">
                            <div className="row">
                                <div className="col-12 text-center">
                                    {!store.uiCheckout.processing && (
                                        <button
                                            type="button"
                                            className={`btn btn-checkout btn-checkout-yellow${store.PortalID === 3 ? ' btn-checkout-yellow-portal3' : ''}`}
                                            aria-label="Place Order"
                                            onClick={this.placeOrderMyFrames}
                                        >
                                            Place Order
                                        </button>
                                    )}
                                </div>
                            </div>
                        </div>
                    )}
                {this.isTestOrder && store.checkout.cstep === ICheckoutStep.payment && (
                    <div className="payment-codes">
                        <div className="row">
                            <div className="col-12 text-center">
                                {!store.uiCheckout.processing && (
                                    <button
                                        type="button"
                                        className={`btn btn-checkout btn-checkout-yellow${store.PortalID === 3 ? ' btn-checkout-yellow-portal3' : ''}`}
                                        aria-label="Place Order"
                                        onClick={this.placeOrderMyFrames}
                                    >
                                        Place Test Order
                                    </button>
                                )}
                            </div>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

@observer
class PaymentComponentContainer extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className="payment">
                <div
                    className="checkout-header"
                    style={{color: store.PortalID === 3 ? '#33393a' : '', backgroundColor: store.PortalID === 3 ? '#edece9' : ''}}
                >
                    3. {store.checkout.isMyFrames ? 'Place Order' : 'Payment Information'}
                    {store.checkout.cstep >= ICheckoutStep.payment && (
                        <span
                            className="fas fa-caret-down"
                            aria-hidden={true}
                            style={{
                                fontSize: 20,
                                paddingRight: 12,
                                marginTop: 14,
                                float: 'right',
                                color: '#FFF',
                            }}
                        />
                    )}
                </div>

                {store.checkout.cstep >= ICheckoutStep.payment && <PaymentComponent />}
                <div
                    className="checkout-header"
                    style={{marginTop: 12, color: store.PortalID === 3 ? '#33393a' : '', backgroundColor: store.PortalID === 3 ? '#edece9' : ''}}
                >
                    4. Payment
                </div>

                {store.checkout.messages
                    .filter(o => o.msgType === ICheckoutMessageType.payment)
                    .map((o, i) => (
                        <div className="row">
                            <div className="col-12">
                                <div
                                    key={i}
                                    className="alert alert-danger form-error"
                                >
                                    <div className="error-title">Payment Error</div>
                                    <div>{o.msg && o.msg.toString()}</div>
                                </div>
                            </div>
                        </div>
                    ))}
            </div>
        );
    }
}

export default PaymentComponentContainer;
